import { UIGameCanvasController } from '../../../shared/scripts/ui_game/UIGameCanvasController.ts';
import { UIGameResponsiveController } from '../../../shared/scripts/ui_game/UIGameResponsiveController.ts';
export class UIWGameCanvasController extends UIGameCanvasController {
    get chatWidth() {
        return this.itemSize * 4;
    }
    get feedsHeight() {
        return this.appH - this.itemSize * 5.5;
    }
    get popupWidth() {
        return this.itemSize * 5;
    }
    get bottomViewHeight() {
        return this.itemSize * 3;
    }
    setupGameContainers() {
        super.setCanvasConfigVariables();
        this.kickOffAppLoading();
        this.addTicker();
    }
    constructor(uiGameManager){
        super(uiGameManager);
        this.responsiveController = new UIGameResponsiveController(uiGameManager);
    }
}
